var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandardsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.05 143.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-4{fill:none;stroke:#11ccea;stroke-linecap:round;}.cls-2,.cls-4{stroke-width:7px;}.cls-3{stroke-width:8px;}.cls-4{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m4.1,66.11l47.4-30.7,46.3,26.7-18.6,64.5s-14,11.9-28.4,11.5-28.5-13.5-28.5-13.5L4.1,66.11Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "31.1 97.81 46.9 110.51 73 64.71"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.4,34.01c0-6.6,5.4-12,12-12h60.6c6.6,0,12,5.4,12,12v84.8c0,6.6-5.4,12-12,12h-19.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.6,
    y1: 50.31,
    x2: 110.3,
    y2: 50.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 98.2,
    y1: 61.91,
    x2: 110.3,
    y2: 61.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 97.1,
    y1: 72.91,
    x2: 110.3,
    y2: 72.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 92.6,
    y1: 84.41,
    x2: 110.3,
    y2: 84.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 89.6,
    y1: 95.11,
    x2: 109.2,
    y2: 95.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.4,
    y1: 106.71,
    x2: 110.3,
    y2: 106.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.5,
    y1: 117.71,
    x2: 110.3,
    y2: 117.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.5,32.11h-33.4c-4,0-7.3-3.3-7.3-7.3v-2.6c0-4,3.3-7.3,7.3-7.3h33.4c4,0,7.3,3.3,7.3,7.3v2.6c0,4-3.3,7.3-7.3,7.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 78.8,
    cy: 15.51,
    r: 9.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardsIcon);
export default __webpack_public_path__ + "static/media/standards_icon.a76d820f7765f8af62b5a8a308becdd1.svg";
export { ForwardRef as ReactComponent };